import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How do you ensure the security of web applications?",
    answer: `<p>We understand that security is of paramount importance and we do our best to maintain that level of security. Standing as a trustworthy web application development services provider, we also apply standard procedures like data encryption, use of multi-factor authentication, constant security audit, and compliance with GDPR and other rules and regulations to secure your web apps.</p>`,
  },
  {
    question: "How long does it take to develop a web app?",
    answer: `<p>The time to create a web app depends on its difficulty level and ranges from weeks to months. For example, it may only take 3 to 6 months to build a basic web app with few functions. On the other hand, it can take between six months to a year or even more to build a highly complex web app with a long list of features.</p>`,
  },
  {
    question: "How much does web app development cost?",
    answer: ` <p>The cost of custom web application development in the USA ranges from $35,000 to $200,000 or more depending on the project. Several factors affect the overall web development budget such as the location of the web application development firm, UI/UX design of the web app, technologies to be used, features to be integrated, etc. Let’s connect with our web app developers to provide you with a better estimation of the cost.</p>`,
  },
  {
    question: "Why choose TekRevol for web application development?",
    answer: `<p>What differentiates us as a custom website development company is our capacity to deliver integrated web applications with advanced frameworks and a user-focused UI/UX. Being the top-rated custom USA web app development company, we deliver services of the highest quality while keeping the costs in check.</p>
    <p>Therefore, if you were searching for “web app developers near me,” look no further. We are your strategic technology partner who can assist you in delivering efficient web application development solutions, feel free to contact us now.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Web Application Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
